export default {
  acab: 'ACAB',
  actions: 'कार्यों',
  addProduct: 'उत्पाद जोड़ें',
  arcPosition: 'एआरसी स्थिति',
  businessId: 'व्यापार आईडी',
  businessPhone: 'व्यवसायिक दूरभाष',
  cancel: 'रद्द करना',
  client: 'ग्राहक',
  clientReference: 'ग्राहक संदर्भ',
  clients: 'ग्राहकों',
  clientSuccessfullyCreated: 'क्लाइंट सफलतापूर्वक बनाया गया',
  clv: 'CLV',
  codeLab: 'कोड लैब',
  colimptexCode: 'Colimptex कोड',
  color: 'रंग',
  colors: 'रंग की',
  colorSuccessfullyCreated: 'रंग सफलतापूर्वक बनाया गया',
  colorSuccessfullyUpdated: 'रंग सफलतापूर्वक अपडेट किया गया',
  composition: 'रचना',
  contactPerson: 'संपर्क करें',
  container: 'पात्र',
  containers: 'कंटेनर',
  containerSuccessfullyCreated: 'कंटेनर सफलतापूर्वक बनाया गया',
  containerSuccessfullyUpdated: 'कंटेनर सफलतापूर्वक अपडेट किया गया',
  createClient: 'क्लाइंट बनाएं',
  createColor: 'रंग बनाएं',
  createContainerType: 'कंटेनर प्रकार बनाएं',
  createOrderDetail: 'ऑर्डर डिटेल बनाएं',
  createOrder: 'ऑर्डर बनाएं',
  createProduct: 'उत्पाद बनाएं',
  createPurchase: 'खरीद बनाएं',
  createPurchaseDetail: 'खरीद की डिटेल बनाएं',
  createSeller: 'विक्रेता बनाएं',
  createSupplier: 'सप्लायर बनाएं',
  created: 'सफलतापूर्वक बनाया गया',
  crf: 'CRF',
  csf: 'CSF',
  currency: 'मुद्रा',
  deleteClient: 'क्लाइंट को हटाएं',
  deletePurchase: 'खरीद हटाएं',
  doYouWantToDeleteThisClient: 'क्या आप वास्तव में इस ग्राहक को हटाना चाहते हैं?',
  doYouWantToDeleteThisColor: 'क्या आप वास्तव में इस रंग को हटाना चाहते हैं?',
  doYouWantToDeleteThisContainer: 'क्या आप वास्तव में इस कंटेनर को हटाना चाहते हैं?',
  doYouWantToDeleteThisProduct: 'क्या आप वास्तव में इस उत्पाद को हटाना चाहते हैं?',
  doYouWantToDeleteThisPurchase: 'क्या आप वास्तव में इस खरीद को हटाना चाहते हैं?',
  doYouWantToDeleteThisSeller: 'क्या आप वास्तव में इस विक्रेता को हटाना चाहते हैं?',
  doYouWantToDeleteThisSupplier: 'क्या आप वास्तव में इस आपूर्तिकर्ता को हटाना चाहते हैं?',
  editAddedProduct: 'जोड़ा उत्पाद संपादित करें',
  editClient: 'ग्राहक को संपादित करें',
  editColor: 'रंग संपादित करें',
  editContainer: '',
  editOrderDetail: 'ऑर्डर डिटेल को एडिट करें',
  editOrder: 'आदेश संपादित करें',
  editProduct: 'उत्पाद को संपादित करें',
  editProvider: 'संपादित प्रदाता',
  editPurchase: 'खरीद संपादित करें',
  editSeller: 'विक्रेता को संपादित करें',
  editSupplier: 'आपूर्तिकर्ता संपादित करें',
  email: 'ईमेल',
  enterDescription: 'उपयोगकर्ता का विवरण दर्ज करें',
  factory: 'फ़ैक्टरी',
  fca: 'FCA',
  fiber: 'रेशा',
  finalKilogramsQuantity: 'किलोग्राम में अंतिम मात्रा',
  finalMetersQuantity: 'मीटर में अंतिम मात्रा',
  finished: 'ख़त्म होना',
  hs: 'HS',
  iva: 'IVA',
  key: 'चाभी',
  kilogramsMaximumCapacity: 'किलोग्राम में अधिकतम क्षमता',
  label: 'लेबल',
  language: 'भाषा: हिन्दी',
  loading: 'लोड...',
  metersKilogramsQuantity: 'm/kg मात्रा',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: 'आइटम बनाने से पहले शुल्क देना होगा',
  name: 'नाम',
  newClient: 'नए ग्राहक',
  newColor: 'नया रंग',
  newContainer: '',
  newOrderDetail: 'नए आदेश का विस्तार',
  newOrder: 'नया आदेश',
  newProduct: 'नया उत्पाद',
  newProvider: 'नया प्रदाता',
  newPurchase: 'नई खरीद',
  newSeller: 'नया विक्रेता',
  newSupplier: 'नई खरीद',
  nit: 'पहचान संख्या',
  noElementsRegistered: 'कोई तत्व पंजीकृत नहीं',
  onlyNumbersAllowed: 'केवल संख्या की अनुमति है',
  paint: 'रंग',
  performance: 'प्रदर्शन',
  phone: 'फोन',
  portOccupation: 'पोर्ट ऑक्यूपेशन',
  print: 'मुद्रण',
  productionDate: 'उत्पादन की तिथि',
  product: 'उत्पाद',
  products: 'उत्पाद',
  productSuccessfullyCreated: 'उत्पाद सफलतापूर्वक बनाया गया',
  productSuccessfullyUpdated: 'उत्पाद सफलतापूर्वक अपडेट किया गया',
  profileImagePath: 'प्रोफ़ाइल छवि url',
  psv: 'PSV',
  purchaseSuccessfullyCreated: 'खरीद सफलतापूर्वक बनाई गई',
  purchaseSuccessfullyUpdated: 'खरीद सफलतापूर्वक अपडेट की गई',
  pvp: 'PVP',
  referenceInChina: 'चीन में संदर्भ',
  rgb: 'RGB',
  requiredAmount: 'आवश्यक धन',
  requirement: 'आवश्यकता',
  save: 'सहेजें',
  search: 'खोज',
  seller: 'विक्रेता',
  sellers: 'सेलर्स',
  sellerSuccessfullyCreated: 'विक्रेता सफलतापूर्वक बनाया गया',
  sellerSuccessfullyUpdated: 'विक्रेता सफलतापूर्वक अपडेट किया गया',
  shippingDate: 'शिपिंग तारीख',
  shortName: 'संक्षिप्त नाम',
  sku: 'SKU',
  subInvoice: 'उप चालान',
  sublimation: 'उच्च बनाने की क्रिया',
  supplier: 'प्रदायक',
  suppliers: 'आपूर्तिकर्ता',
  supplierSuccessfullyCreated: 'आपूर्तिकर्ता सफलतापूर्वक बनाया गया',
  supplierSuccessfullyUpdated: 'आपूर्तिकर्ता सफलतापूर्वक अपडेट किया गया',
  taxesRefund: 'टैक्स रिफंड',
  totalAmount: 'कुल रकम',
  trm: 'TRM',
  typeOfContainer: 'कंटेनर का प्रकार',
  updated: 'सफलतापूर्वक अपडेट किया गया',
  unitMeasure: 'माप की इकाई',
  viewClient: 'देखें क्लाइंट',
  weight: 'वजन',
  wide: 'चौड़ा',
  withholdingTax: 'कर काटना'
}
